import validate from "/home/denis/sources/nova-plateform-web/node_modules/nuxt/dist/pages/runtime/validate.js";
import default_45global from "/home/denis/sources/nova-plateform-web/middleware/default.global.ts";
export const globalMiddleware = [
  validate,
  default_45global
]
export const namedMiddleware = {}